import { render } from "./NoResultsSection.vue?vue&type=template&id=49c69ce6"
import script from "./NoResultsSection.vue?vue&type=script&lang=js"
export * from "./NoResultsSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__